export default __webpack_public_path__ + "static/media/refresh.6357403c.svg";